import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { useButton } from '@react-aria/button';
import { useRef } from 'react';
/**
 * Name tag is a type of **molecule** that represent user by a rectangular name tag.
 */
const NameTag = ({ className, firstName, lastName, onClick, ...rest }) => {
    const dataAttributes = useDataAttributes(rest);
    const buttonRef = useRef(null);
    const { buttonProps } = useButton({ elementType: 'span', onPress: onClick }, buttonRef);
    return (_jsx("span", { ...buttonProps, className: buildClassName('skyline-text-caption-2 cursor-default border-none text-white', 'rounded px-2 py-[5px]', className), ref: buttonRef, ...dataAttributes, children: `${firstName} ${lastName}` }));
};
export default NameTag;
//# sourceMappingURL=NameTag.js.map